module.exports = __webpack_public_path__ + "img/queshen.1f5af4b8.png";